import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import { HttpMethods, SERVICES } from '../../services/api';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { ThunkAPI } from '../rootReducer';

export interface IUserCreationFromProspect {
  email: string;
  password: string;
  hash: string;
}

export const createUserFromProspect: AsyncThunk<void, IUserCreationFromProspect, ThunkAPI> = createAsyncThunk(
  'auth/createUserFromProspect',
  async (data: IUserCreationFromProspect, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IUserCreationFromProspect>({
        endpoint: 'prospects/register',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: false,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(data, thunk);
      thunk.dispatch(push('/login'));
      thunk.dispatch(showSuccessMessage('You have been registered!'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('Your request failed. Your reset invitation link may have expired, please try again'));
      return thunk.rejectWithValue(err);
    }
  }
);